import { useEffect, useRef } from 'react';

import { useToggle } from 'react-use';

import { getCastingSessionEventSource } from 'services/networking/casting';
import { PlayerEventsListeners } from 'shared-types/player-event';

export const useCastingListener = (
  eventListeners: PlayerEventsListeners,
  castingSessionId: string | null | undefined,
) => {
  const [listeningToSSE, setListeningToSSE] = useToggle(false);
  const castingSessionEventSource = useRef<EventSource>();

  useEffect(() => {
    if (!listeningToSSE && castingSessionId) {
      try {
        castingSessionEventSource.current = getCastingSessionEventSource(castingSessionId);
      } catch (error) {
        console.error('Event source creation failed because of following error\n', error);
        return;
      }
      setListeningToSSE(true);
    }
    return () => {
      if (listeningToSSE) {
        castingSessionEventSource.current?.close();
        setListeningToSSE(false);
      }
    };
  }, [listeningToSSE, setListeningToSSE, castingSessionId]);

  useEffect(() => {
    if (castingSessionEventSource.current) {
      for (const [eventType, eventHandler] of Object.entries(eventListeners)) {
        castingSessionEventSource.current.addEventListener(
          eventType,
          eventHandler as EventListener,
        );
      }
    }
    return () => {
      if (castingSessionEventSource.current) {
        for (const [eventType, eventHandler] of Object.entries(eventListeners)) {
          castingSessionEventSource.current?.removeEventListener(
            eventType,
            eventHandler as EventListener,
          );
        }
      }
    };
  }, [eventListeners]);
};
